import React from 'react';
import { AppBar } from '@mui/material';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Logo from 'components/logo';
import Box from '@mui/material/Box';
import HeaderDropdown from 'components/header-dropdown';
import ColorModeContext from 'common/color-mode-context';
import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from '@mui/material/styles';
import styles from './styles';

const Header = () => {
  const theme = useTheme();
  const colorMode = React.useContext(ColorModeContext);

  return (
    <AppBar position='static' color={'inherit'} sx={styles.appBar}>
      <Container maxWidth='xl'>
        <Toolbar disableGutters>
          <Logo url='/' />

          <Box sx={styles.headerRight}>
            <>
              <IconButton sx={{ ml: 1 }} onClick={colorMode.toggleColorMode}>
                {theme.palette.mode === 'dark' ? (
                  <Brightness7Icon />
                ) : (
                  <Brightness4Icon />
                )}
              </IconButton>

              <HeaderDropdown />
            </>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
